module.exports = __webpack_public_path__ + "img/IMG_2503-2.d80b15dc.jpg";